import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import {
    resetAction,
} from 'one-state-skeleton';
import {
    RESET,
} from 'one-state-subject/src/types';

/**
 * This Fuction will clear data of skeleton epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearSkeletonEpic = (context: any) => (
    (action$: any) => {
        const { log} = context;
        log.debug(
            "ccw-gadget,skeleton-epic",
            "Reset-Skeleton-epic", {
            });
        return action$.pipe(
            ofType(RESET),
            map(action => resetAction())
        )
    }
);